export const helpCenter = [
  {
    path: "/helpCenter",
    name: "HelpCenter",
    component: () => import("@/views/helpCenter/index.vue"),
    meta: {
      title: "帮助中心",
      icon: "shangpin",
    },
  },
];
